import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { ContrasenaService } from './contrasena.service';
import { ContrasenaListComponent } from './contrasena-list.component';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import * as myGlobals from './../global';

@Component({
  selector: 'pm-contrasena',
  templateUrl: './contrasena.component.html',
  styleUrls: ['./contrasena.component.sass']
})
export class ContrasenaComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'CONTRASEÑA';

  error: boolean;
  errorMessage: string;

  constructor(
    public service: ContrasenaService,
    private parent: ContrasenaListComponent,
    private router: Router,
    private spinnerService: NgxSpinnerService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    $('body').addClass('backgroundLogin');
  }

  beginPasswordChange(): void {
    this.service.emailData = {
      // Stored emails are lowercase and the lookup is case-sensitive
      email: String($('input[name=email]').val() || '').trim().toLowerCase() /* ,
      status: $('#myselect option:selected').val() */
    };
    this.spinner();
    console.log('ContrasenaComponent: beginPasswordChange: formData: ', this.service.emailData);
    // this.parent.showContrasena = false;
    // this.parent.showChangeContrasena = true;
    // this.parent.showConfirmContrasena = false;

    this.service.startPasswordChange(this.service.emailData).subscribe(
      res => {
        console.log('ContrasenaComponent: beginPasswordChange: res: ', res);
        this.parent.showContrasena = false;
        this.parent.showChangeContrasena = true;
        this.parent.showConfirmContrasena = false;
        // this.router.navigate(['/contrasena-confirm']);
      },
      err => {
        this.error = true;
        // console.log('ContrasenaComponent: beginPasswordChange: err: ', err);
        // console.log(err.error.message);
        this.errorMessage = err.error.message;
      }
    );
  }

  cancelPasswordChange(): void {
    this.parent.showContrasena = true;
    this.parent.showConfirmContrasena = false;
    this.router.navigate(['']);
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 2000);
  }

  ngOnDestroy() {}
}
